var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheBanner',{attrs:{"title":this.$lang.downloadsTitle,"description":this.$lang.downloadsSubtitle,"image":"cover.jpeg"}}),_c('ListView',{staticClass:"body-block",attrs:{"data":_vm.downloads,"id":"grid","type":"pop"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }